module.exports = require("swagger-client");


//////////////////
// WEBPACK FOOTER
// external "swagger-client"
// module id = 235
// module chunks = 0